// extracted by mini-css-extract-plugin
export var content = "AboutValues-module--content--272b2";
export var cta = "AboutValues-module--cta--9b29e";
export var group = "AboutValues-module--group--6e847";
export var groupwrapper = "AboutValues-module--groupwrapper--eb7ae";
export var logo = "AboutValues-module--logo--05e87";
export var title = "AboutValues-module--title--1f97e";